// Widget lifecycle hook. Gets fired when Okendo Widgets are finished initializing
window.okeReviewsWidgetOnInit = function () {
    const reviewMain = document.querySelector('.js-okeReviews-reviews-main');
    if (reviewMain) {
        const callback = function (mutationList) {
            for (const mutation of mutationList) {
                mutation.addedNodes.forEach(n => setupIndividualReviews(n));
            }
        };
        const observer = new MutationObserver(callback);
        observer.observe(reviewMain, { childList: true });
        // Run callback for the first time
        const reviews = document.querySelectorAll('.okeReviews-reviews-review');
        reviews.forEach(n => setupIndividualReviews(n));
    }
};

function setupIndividualReviews(nodeElement) {
    if (nodeElement) {
        const reviewerDetails = nodeElement.querySelector('.okeReviews-review-reviewer-profile-details');
        const starRating = nodeElement.querySelector('.okeReviews-review-starRating');

        // Move star rating above reviewer name
        if(reviewerDetails && starRating) {
            reviewerDetails.insertAdjacentElement('beforebegin', starRating);
        }

        const reviewDate = nodeElement.querySelector('.okeReviews-review-date');

        // Move date below reviewer name
        if(reviewerDetails && reviewDate) {
            reviewerDetails.insertAdjacentElement('beforeend', reviewDate);
        }
        

        // Format Date to MM/dd/yy
        const dateFormat = new Intl.DateTimeFormat('en-GB', {
            month: 'short',
            day: '2-digit',
            year: 'numeric'
        });

        const reviewDates = document.querySelectorAll('[data-oke-reviews-date]');
        for (const reviewDate of reviewDates) {
            const dateIsoString = reviewDate.getAttribute('data-oke-reviews-date');
            const date = new Date(dateIsoString);
            const localeDate = `${dateFormat.format(date)}`;
            reviewDate.innerText = localeDate;
        }
    }
}